import { render, staticRenderFns } from "./ManagerPagination.vue?vue&type=template&id=fcf89606&scoped=true"
import script from "./ManagerPagination.vue?vue&type=script&lang=js"
export * from "./ManagerPagination.vue?vue&type=script&lang=js"
import style0 from "./ManagerPagination.vue?vue&type=style&index=0&id=fcf89606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_b4d2f5f63767a7c4cbcbe44ae7bf34d4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf89606",
  null
  
)

export default component.exports